import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { THREE_LETTER_EU_COUNTRY_CODES } from "./THREE_LETTER_EU_COUNTRY_CODES";
export var THREE_LETTER_EUROPE_COUNTRY_CODES = _object_spread_props(_object_spread({}, THREE_LETTER_EU_COUNTRY_CODES), {
    ALA: "ALA",
    ALB: "ALB",
    AND: "AND",
    ARM: "ARM",
    AZE: "AZE",
    BIH: "BIH",
    BLR: "BLR",
    CHE: "CHE",
    FRO: "FRO",
    GBR: "GBR",
    GEO: "GEO",
    GGY: "GGY",
    GIB: "GIB",
    IMN: "IMN",
    ISL: "ISL",
    JEY: "JEY",
    KAZ: "KAZ",
    LIE: "LIE",
    MCO: "MCO",
    MDA: "MDA",
    MKD: "MKD",
    MNE: "MNE",
    NOR: "NOR",
    RUS: "RUS",
    SJM: "SJM",
    SMR: "SMR",
    SRB: "SRB",
    TUR: "TUR",
    UKR: "UKR",
    VAT: "VAT",
    XKX: "XKX"
});
